import { SnackbarProvider } from "notistack";
import React, { Component } from "react";
import { MyLoadingIndicator } from "../components/my-loading-indicator/MyLoadingIndicator";
import { SnackbarUtilsConfigurator } from "../SnackbarUtils";
import { MyThemeProvider } from "./MyThemeProvider";

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <MyThemeProvider>
        <SnackbarProvider
          SnackbarProps={{
            "aria-live": "polite",
          }}
        >
          <SnackbarUtilsConfigurator />
          {this.props.children}
        </SnackbarProvider>
        <MyLoadingIndicator />
      </MyThemeProvider>
    );
  }
}
